module.exports = __webpack_public_path__ + "static/media/3.fea838f4.svg";